import ClientsEditorBase from "./ClientsEditorBase.jsx";
import {PERSISTENCE_STATE_KEYS} from "../../../other/constants/PersistenceStateKeys.jsx";
import {HasChecklistBaseMixin} from "../../widget/mixins/HasChecklistBaseMixin.jsx";
import { DEEP_LINK_URL_KEYS } from "../../../other/constants/OtherKeys.jsx";

export default class ClientChecklistTab extends HasChecklistBaseMixin(ClientsEditorBase) {
  static get $name() {
    return "ClientChecklistTab";
  }

  static get type() {
    return "clientchecklisttab";
  }

  get stateId() {
    return PERSISTENCE_STATE_KEYS.clientChecklistGrid;
  }

  get recordType() {
    return "clientId";
  }

  get entityType() {
    return "client";
  }

  get deepLinkUrlKey() {
    return DEEP_LINK_URL_KEYS.client;
  }
}

ClientChecklistTab.initClass();